import React from 'react';
import { Badge, Icon } from 'antd';
import moment from 'moment';
import styles from './UserBudgetCreditsRequestNotification.module.scss';

export default function UserBudgetCreditsRequestNotification(props) {
  const { notification, onClick, featureToggleList } = props;
  const { Payload: payload, UpdatedTime: updatedTime, UnreadCount: unreadCount } = notification;
  const isUserBudgetFeatureEnabled = featureToggleList.UserBudgetCapping.IsEnabled;

  return isUserBudgetFeatureEnabled ? (
    <div className={styles.notification} role="presentation" onClick={() => onClick(notification)}>
      <div className={styles.requestIcon}>
        <Icon style={{ fontSize: 20, color: '#2d2e67' }} type="clock-circle" />
      </div>
      <div className={styles.content}>
        <div className={styles.notificationTitle}>Credit Request</div>
        <div className={styles.message}>{`${payload} has requested for User credits for their account.`}</div>
        <div className={styles.time}>{moment.utc(updatedTime).local().fromNow()}</div>
      </div>
      <div className={styles.viewSymbol}>
        <Badge dot={unreadCount > 0} />
      </div>
    </div>
  ) : null;
}
